type ContentType = 'skills' | 'goal' | 'task' | 'training'
export const Tag = {}

export const statusColors = {
  warning: {
    color: 'warning.200',
    bg: 'warning.0',
    border: 'warning.50',
  },
  success: {
    color: 'success.300',
    bg: 'success.25',
    border: 'success.50',
  },
  error: {
    color: 'error.100',
    bg: 'error.0',
    border: 'error.25',
  },
}

export const contentTypeColors = {
  skills: { color: 'blue.500', bg: 'blue.50', border: 'blue.100' },
  goal: { color: 'green.500', bg: 'green.50', border: 'green.100' },
  task: { color: 'red.500', bg: 'red.50', border: 'red.100' },
  training: {
    color: 'error.100',
    bg: 'error.0',
    border: 'error.25',
  },
}

export const contentTypeLabels = {
  skills: 'Skill',
  goal: 'Goal',
  task: 'Task',
}
